
export function CPRRouterPatch(router) {
    return {
        install(app) {
            if (!router) {
                console.warn("Vue Router is not available in this app.")
                return
            }

            // Override push to allow clicking the same link
            const originalPush = router.push

            router.push = async function (location, onComplete, onAbort) {
                try {
                    const resolvedPath = router.resolve(location).fullPath
                    const currentPath = router.currentRoute.value.fullPath

                    if (resolvedPath === currentPath) {
                        await router.replace({
                            path: resolvedPath,
                            query: { _refresh: Date.now() },
                        })
                    } else {
                        return originalPush.call(router, location, onComplete, onAbort)
                    }
                } catch (error) {
                    console.error("Navigation error:", error)
                }
            }

            // Scroll to top on route change
            router.options.scrollBehavior = () => ({ top: 0 })

            //console.log("Router patch applied")
        },
    }
}